import React from "react";
import "./Pumpkin.css";

export default function Pumpkin() {
  return (
    <div className="container">
      <svg
        width="291"
        height="272"
        viewBox="0 0 291 272"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="pumpkin">
          <g id="pumpkin-body">
            <ellipse cx="116.5" cy="134.5" rx="55.5" ry="86.5" fill="url(#paint0_radial)" />
            <ellipse cx="172.5" cy="138.5" rx="55.5" ry="86.5" fill="url(#paint1_radial)" />
            <path
              d="M170.5 77.1094C138.9 63.9094 166.667 26.9428 184.5 10.1094C186.167 8.60942 186.6 4.90942 175 2.10942C163.4 -0.690578 126.833 50.9428 110 77.1094H170.5Z"
              fill="url(#paint2_linear)"
            />
            <ellipse cx="211.256" cy="156.339" rx="71.2557" ry="96.3391" fill="url(#paint3_radial)" />
            <ellipse cx="185.256" cy="164.339" rx="71.2557" ry="96.3391" fill="url(#paint4_radial)" />
            <ellipse cx="75.2557" cy="148.339" rx="71.2557" ry="96.3391" fill="url(#paint5_radial)" />
            <ellipse cx="94.2557" cy="156.339" rx="71.2557" ry="96.3391" fill="url(#paint6_radial)" />
            <ellipse cx="141.114" cy="166.962" rx="71.2557" ry="96.3391" fill="url(#paint7_radial)" />
          </g>

          <g id="face">
            {/* Eyes */}
            <path d="M85.66 143.786C50.6055 95.1616 76.6003 88.1166 88.2005 91.8505C92.2648 106.107 116.48 119.938 123 115.27C123 142.004 95.7551 157.789 85.66 143.786Z" />
            <path d="M209.624 143.786C242.129 95.1616 218.025 88.1166 207.269 91.8505C203.5 106.107 181.046 119.938 175 115.27C175 142.004 200.263 157.789 209.624 143.786Z" />

            {/* Nose */}
            <path d="M137.124 149.923C137.768 151.665 140.232 151.665 140.876 149.923L144.933 138.943C145.416 137.637 144.449 136.25 143.057 136.25H134.943C133.551 136.25 132.584 137.637 133.067 138.943L137.124 149.923Z" />
            <path d="M159.124 149.923C159.768 151.665 162.232 151.665 162.876 149.923L166.933 138.943C167.416 137.637 166.449 136.25 165.057 136.25H156.943C155.551 136.25 154.584 137.637 155.067 138.943L159.124 149.923Z" />

            {/* Mouth */}
            <path d="M74.4291 177.596C67.7297 196.422 36.4662 172.367 32 167.661L53.7728 193.807V206.881L69.4046 213.679C68.6602 207.578 67.6181 195.899 69.4046 197.991C71.1911 200.083 85.7807 203.394 92.8522 204.789V216.294H112.392L111.275 204.789C118.868 208.972 124.488 206.532 126.349 204.789L124.116 221H156.496L154.263 204.789C161.409 208.972 172.128 206.532 176.594 204.789V216.294H197.808L196.692 204.789H220.698L218.465 213.679H238.563L236.888 204.789C246.378 206.358 268.16 164.821 260.335 174.459C257.788 177.596 242.471 193.284 227.397 185.44L230.747 175.505L208.416 174.459C208.416 178.642 211.207 176.028 211.207 185.44C211.207 192.842 191.667 187.532 185.526 185.44L187.759 174.459H162.079C160.962 176.55 164.312 185.44 164.312 185.44C164.312 185.44 141.981 187.532 134.165 185.44L136.398 164H110.159L111.275 185.44C97.4301 190.461 93.2244 187.532 92.8522 185.44L94.5271 164H74.4291V177.596Z" />
          </g>
        </g>
      </svg>
    </div>
  );
}
